import React, {
    useEffect, useState, useMemo
} from "react";
import { useTranslation } from "react-i18next";
import { getToken, toNumber } from "../../utils/auth";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CONFIG from "../../config";

const MagicWriterAdmin = () => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language?.startsWith('ar');
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const navigate = useNavigate();

    // useEffect(() => {
    //     const fetchConfig = async () => {
    //         try {
    //             const token = getToken();
    //             const res = await axios.get(`${CONFIG.API_URL}/api/admin/ai/config`, {
    //                 headers: { Authorization: `Bearer ${token}` }
    //             });
    //             setConfig(res.data);
    //             if (!res.data) {
    //                 setError("AI configuration not found. Please configure AI settings first.");
    //             }
    //         } catch (err) {
    //             console.error("Failed to fetch AI config", err);
    //             setError("Failed to load AI configuration. Please check your connection.");
    //         } finally {
    //             setLoading(false);
    //         }
    //     };
    //     fetchConfig();
    // }, []);
    useEffect(() => {
        let mounted = true;

        const fetchConfig = async () => {
            try {
                const token = getToken();
                const { data } = await axios.get(`${CONFIG.API_URL}/api/admin/ai/config`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (!mounted) return;

                setConfig(data);

                if (!data) {
                    setError("AI configuration not found. Please configure AI settings first.");
                }
            } catch (err) {
                if (!mounted) return;
                console.error("Failed to fetch AI config", err);
                setError("Failed to load AI configuration.");
            } finally {
                if (mounted) setLoading(false);
            }
        };

        fetchConfig();

        return () => {
            mounted = false;
        };
    }, []);

    // Build the magic-writer-ai URL with the API configuration
    // const getMagicWriterUrl = () => {
    //     if (!config) return null;

    //     // Pass configuration via query parameters to the iframe
    //     const baseUrl = "/magic-writer/";
    //     const params = new URLSearchParams({
    //         apiUrl: CONFIG.API_URL,
    //         provider: config.provider || '',
    //         model: config.model || '',
    //         systemPrompt: config.system_prompt || '',
    //         maxTokens: String(config.max_tokens || 1000),
    //         temperature: String(config.temperature || 0.7)
    //     });
    //     return `${baseUrl}?${params.toString()}`;
    // };
    const magicWriterUrl = useMemo(() => {
        if (!config) return null;

        const params = new URLSearchParams({
            apiUrl: CONFIG.API_URL,
            provider: config.provider || "",
            model: config.model || "",
            systemPrompt: config.system_prompt || "",
            maxTokens: String(toNumber(config.max_tokens, 1000)),
            temperature: String(toNumber(config.temperature, 0.7))
        });

        return `/magic-writer/?${params.toString()}`;
    }, [config]);

    if (loading) {
        return (
            <div className="p-20 text-center animate-pulse">
                {t('admin.common.loading', 'Loading...')}
            </div>
        );
    }

    if (error) {
        return (
            <div className="max-w-4xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
                <div className="bg-red-50 border border-red-200 text-red-700 px-6 py-4 rounded-xl">
                    <div className="flex justify-between gap-0 m-0">
                        <h2 className="font-bold text-lg mb-0">Cannot Load Magic Writer</h2>
                        <button
                            onClick={() => navigate("/admin")}
                            className="flex items-center gap-2 m-0 text-red-500 hover:text-brand-primary transition-all text-sm font-medium group"
                        >
                            <span className={`transition-transform group-hover:-translate-x-1 ${isArabic ? "rotate-180 group-hover:translate-x-1" : ""}`}>←</span>
                            {t('admin.common.back', 'Back')}
                        </button>
                    </div>
                    <p>{error}</p>
                    <p className="mt-2 text-sm">
                        Please configure AI settings in the <a href="/admin/ai" className="text-blue-600 hover:underline">AI Configuration</a> page first.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="h-[calc(100vh-200px)] mt-24">
            <iframe
                // src={getMagicWriterUrl()}
                src={magicWriterUrl}
                title="Magic Writer AI"
                className="w-full h-full border-none rounded-[30px] shadow-2xl"
                allow="clipboard-read; clipboard-write"
            />
        </div>
    );
};

export default MagicWriterAdmin;
